<script>
import { mapState } from "vuex";
import SiteMenuFlyoutLayout from "./SiteMenuFlyoutLayout.vue";

export default {
  components: {
    SiteMenuFlyoutLayout,
  },

  props: {
    heading: {
      type: String,
      default: null,
    },
    theme: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      openedMenu: null,
      prevSiteTheme: null,
    };
  },

  computed: {
    ...mapState({
      siteTheme: (state) => state.ui.siteTheme,
    }),
  },

  created() {
    if (this.theme) {
      this.prevSiteTheme = Object.keys(this.siteTheme).map(
        (key) => this.siteTheme[key]
      );
      this.$store.commit("setSiteTheme", this.theme);
    }
  },

  destroyed() {
    if (this.prevSiteTheme) {
      this.$store.commit("setSiteTheme", this.prevSiteTheme);
    }
  },

  methods: {
    openMenu(key) {
      this.openedMenu = key;
    },
    closeMenu() {
      this.openedMenu = null;
    },
    isOpenedMenu(key) {
      return key === this.openedMenu;
    },
  },
};
</script>
